import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./portfolioCarousel.css";
import "../services/services.css";
import Stamurai from "../images/stamurai.PNG";
import SafariSmart from "../images/safariAdminCustomers.PNG";
import Portfolio from "./portfolio";
const options = {
  items: 4,
  loop: true,
  margin: 10,
  responsiveClass: true
};
let responsive = {
  0: {
    items: 1,
    nav: true,
    loop: true
  }
};

const PortfolioData = [
  {
    title: "Bybrisk",
    image: "https://bit.ly/3D35gdO",
    desc:
      "Bybrisk is a Hyper delivery Optimization Startup in Bhopal. It helps vendors in bulk deliveries and managing their resources. Bybrisk helps logistic companies in last mile delivery and reduce their costs.",
    content: [
      "Contributed to Bybrisk web tool",
      "Built Live Location Tracking",
      "Built Delivery and Agent Management System, Cluster Management System",
      "Optimized plotting delivery on Google Map"
    ]
  },
  {
    title: "Safari Smart",
    image: SafariSmart,
    desc:
      "Safari Smart provides a single platform for managing logistics and deliveries and helping disrupted logistic markets in Tanzania to come at a single platform.",
    content: [
      "Multi Vendor Logistic management",
      "Designed Full UI/UX",
      "Multi Role Routing",
      "Parcel Tracking System, Truck Status,Employee management, Customer management and Parcel management."
    ]
  },
  {
    title: "Stamurai",
    image: Stamurai,
    desc: "Stamurai helps in providing online stuttering therapy.",
    content: [
      "High Converting Landing Page",
      "On site Lead form",
      "Views Tracking",
      "Highly Responsive Design"
    ]
  }
];

function PortfolioCarousel() {
  return (
    <section className="portfolioContainer">
      <OwlCarousel
        options={options}
        className="owl-theme portfolio-carousel"
        loop
        margin={10}
        nav
        responsiveClass
        responsive={responsive}
        // autoplay
        autoplayTimeout={3000}
        autoplayHoverPause
      >
        <div class="item">
          <Portfolio
            title={PortfolioData[0].title}
            desc={PortfolioData[0].desc}
            content={PortfolioData[0].content}
            image={PortfolioData[0].image}
          />
        </div>
        <div class="item">
          <Portfolio
            title={PortfolioData[1].title}
            desc={PortfolioData[1].desc}
            content={PortfolioData[1].content}
            image={PortfolioData[1].image}
          />{" "}
        </div>
        <div class="item">
          <Portfolio
            title={PortfolioData[2].title}
            desc={PortfolioData[2].desc}
            content={PortfolioData[2].content}
            image={PortfolioData[2].image}
          />{" "}
        </div>
      </OwlCarousel>
    </section>
  );
}
export default PortfolioCarousel;
